export const loginResources = {
  zh: {
    'login.centerName': '家庭友好企业中心',
    'login.welcome': '欢迎回来',
    'login.subtitle': '使用企业账号或邮箱登录',
    'login.accountLabel': '账号',
    'login.accountPlaceholder': '使用企业账号或邮箱登录',
    'login.passwordLabel': '密码',
    'login.passwordPlaceholder': '请输入登录密码',
    'login.rememberMe': '记住我',
    'login.forgotPassword': '忘记密码？',
    'login.submit': '登  录',
    'login.noAccount': '还没有账号？请先',
    'login.register': '提交报名',

    'login.forgot.title': '找回密码',
    'login.forgot.subtitle': '请输入您的登录账号，我们将向绑定邮箱发送验证码',
    'login.forgot.accountLabel': '登录账号/邮箱',
    'login.forgot.accountPlaceholder': '请输入 user ID 或邮箱',
    'login.forgot.next': '下一步',
    'login.forgot.backToLogin': '返回登录',
    'login.forgot.accountNotFound': '账号不存在，请检查后重试',
    'login.forgot.tooManyRequests': '请求过于频繁，请 10 分钟后再试',

    'login.forgot.notActivated.title': '该账号尚未激活',
    'login.forgot.notActivated.desc1': '账号',
    'login.forgot.notActivated.desc2':
      '还未完成首次激活。请先通过激活邮件完成密码设置，无需走找回密码流程。',
    'login.forgot.notActivated.resend': '重新发送激活邮件',
    'login.forgot.notActivated.backToLogin': '返回登录',

    'login.reset.title': '更改密码',
    'login.reset.codeSentTo': '验证码已发送至',
    'login.reset.codeLabel': '邮箱验证码',
    'login.reset.codeValid': '10分钟内有效',
    'login.reset.spamHint': '邮件可能被误判为垃圾邮件，请留意查看',
    'login.reset.resendCode': '重新发送验证码',
    'login.reset.resendCountdown': '重新发送验证码({{seconds}}秒)',
    'login.reset.passwordLabel': '设置登录密码',
    'login.reset.passwordPlaceholder': '长度 8-20',
    'login.reset.passwordHint': '需包含大小写字母、数字、符号中至少 3 类',
    'login.reset.confirmLabel': '确认密码',
    'login.reset.confirmPlaceholder': '再次输入密码',
    'login.reset.submit': '更改密码',
    'login.reset.submitting': '提交中…',
    'login.reset.back': '返回上一步',
    'login.reset.codeError': '验证码不正确，请检查后重试',
    'login.reset.error': '密码重置失败，请重试',
    'login.error.invalid': '账号或密码错误',
  },
  zh_TW: {
    'login.centerName': '家庭友善企業中心',
    'login.welcome': '歡迎回來',
    'login.subtitle': '使用企業賬號或郵箱登錄',
    'login.accountLabel': '賬號',
    'login.accountPlaceholder': '使用企業賬號或郵箱登錄',
    'login.passwordLabel': '密碼',
    'login.passwordPlaceholder': '請輸入登錄密碼',
    'login.rememberMe': '記住我',
    'login.forgotPassword': '忘記密碼？',
    'login.submit': '登  錄',
    'login.noAccount': '還沒有賬號？請先',
    'login.register': '提交報名',

    'login.forgot.title': '找回密碼',
    'login.forgot.subtitle': '請輸入您的登錄賬號，我們將向綁定郵箱發送驗證碼',
    'login.forgot.accountLabel': '登錄賬號/郵箱',
    'login.forgot.accountPlaceholder': '請輸入 user ID 或郵箱',
    'login.forgot.next': '下一步',
    'login.forgot.backToLogin': '返回登錄',
    'login.forgot.accountNotFound': '賬號不存在，請檢查後重試',
    'login.forgot.tooManyRequests': '請求過於頻繁，請 10 分鐘後再試',

    'login.forgot.notActivated.title': '該賬號尚未激活',
    'login.forgot.notActivated.desc1': '賬號',
    'login.forgot.notActivated.desc2':
      '還未完成首次激活。請先通過激活郵件完成密碼設置，無需走找回密碼流程。',
    'login.forgot.notActivated.resend': '重新發送激活郵件',
    'login.forgot.notActivated.backToLogin': '返回登錄',

    'login.reset.title': '更改密碼',
    'login.reset.codeSentTo': '驗證碼已發送至',
    'login.reset.codeLabel': '郵箱驗證碼',
    'login.reset.codeValid': '10分鐘內有效',
    'login.reset.spamHint': '郵件可能被誤判為垃圾郵件，請留意查看',
    'login.reset.resendCode': '重新發送驗證碼',
    'login.reset.resendCountdown': '重新發送驗證碼({{seconds}}秒)',
    'login.reset.passwordLabel': '設置登錄密碼',
    'login.reset.passwordPlaceholder': '長度 8-20',
    'login.reset.passwordHint': '需包含大小寫字母、數字、符號中至少 3 類',
    'login.reset.confirmLabel': '確認密碼',
    'login.reset.confirmPlaceholder': '再次輸入密碼',
    'login.reset.submit': '更改密碼',
    'login.reset.submitting': '提交中…',
    'login.reset.back': '返回上一步',
    'login.reset.codeError': '驗證碼不正確，請檢查後重試',
    'login.reset.error': '密碼重置失敗，請重試',
    'login.error.invalid': '賬號或密碼錯誤',
  },
  en: {
    'login.centerName': 'Family-Friendly Enterprise Center',
    'login.welcome': 'Welcome Back',
    'login.subtitle': 'Sign in with your enterprise account or email',
    'login.accountLabel': 'Account',
    'login.accountPlaceholder': 'Enterprise account or email',
    'login.passwordLabel': 'Password',
    'login.passwordPlaceholder': 'Enter your password',
    'login.rememberMe': 'Remember me',
    'login.forgotPassword': 'Forgot password?',
    'login.submit': 'Sign In',
    'login.noAccount': "Don't have an account? Please",
    'login.register': 'submit registration',

    'login.forgot.title': 'Recover Password',
    'login.forgot.subtitle':
      'Enter your login account and we will send a verification code to your email',
    'login.forgot.accountLabel': 'Login Account / Email',
    'login.forgot.accountPlaceholder': 'Enter user ID or email',
    'login.forgot.next': 'Next',
    'login.forgot.backToLogin': 'Back to Login',
    'login.forgot.accountNotFound': 'Account not found. Please check and try again.',
    'login.forgot.tooManyRequests': 'Too many requests. Please try again in 10 minutes.',

    'login.forgot.notActivated.title': 'Account not yet activated',
    'login.forgot.notActivated.desc1': 'Account',
    'login.forgot.notActivated.desc2':
      'has not been activated. Please complete password setup via the activation email first.',
    'login.forgot.notActivated.resend': 'Resend Activation Email',
    'login.forgot.notActivated.backToLogin': 'Back to Login',

    'login.reset.title': 'Change Password',
    'login.reset.codeSentTo': 'Verification code sent to',
    'login.reset.codeLabel': 'Email Verification Code',
    'login.reset.codeValid': 'Valid for 10 minutes',
    'login.reset.spamHint': 'The email may be marked as spam. Please check your junk folder.',
    'login.reset.resendCode': 'Resend Code',
    'login.reset.resendCountdown': 'Resend Code ({{seconds}}s)',
    'login.reset.passwordLabel': 'Set Login Password',
    'login.reset.passwordPlaceholder': 'Length 8-20',
    'login.reset.passwordHint':
      'Must contain at least 3 of: uppercase, lowercase, numbers, symbols',
    'login.reset.confirmLabel': 'Confirm Password',
    'login.reset.confirmPlaceholder': 'Re-enter password',
    'login.reset.submit': 'Change Password',
    'login.reset.submitting': 'Submitting…',
    'login.reset.back': 'Go Back',
    'login.reset.codeError': 'Incorrect code. Please check and try again.',
    'login.reset.error': 'Password reset failed. Please try again.',
    'login.error.invalid': 'Incorrect account or password.',
  },
};
